import CodedError from '../../util/CodedError';


class ErrorController {
  constructor($sce) {
    this.$sce = $sce;
    this.name = 'error';
  }

  $onInit() {
    this.errorMessage = this.$sce.trustAsHtml(CodedError.getMessage(this.error));
  }
}

ErrorController.$inject = ['$sce'];

export default ErrorController;



// WEBPACK FOOTER //
// ./client/app/components/error/error.controller.js